import React from 'react';
import './Maintenance.scss';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import instagram from './assets/instagram.svg';
import whatsappImage from './assets/whatsapp.svg';

import Logo from 'components/main/Header/Logo';

const Maintenance = (props) => {

    const { whatsapp, maintenance } = props;

    console.log('isMaintenance man', maintenance);
    return (
        <div className="maintenance-page"
        style={{
            background: 'url(/files/maintenance.png) center center / cover no-repeat',
        }}>
            <div className="maintenance-content">
                <div className="maintenance-logo">
                    <Logo />
                </div>
                <h1>{maintenance.titulo}</h1>
                <p>{maintenance.texto_informativo}</p>
                <div className="social-links">
                <a href="https://www.instagram.com/craco.oficial/" target="_blank" rel="noreferrer">
                    <i className="icon-instagram" />
                    <img src={instagram} className="image-redes-footer" alt="instagram" />

                </a>
                {whatsapp && (
                    <a href={`https://wa.me/${whatsapp.number}`} target="_blank" rel="noreferrer">
                        <i className="icon-whatsapp" />
                        <img src={whatsappImage} className="image-redes-footer" alt="whatsapp" />

                    </a>
                )}
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
  whatsapp: state.app.whatsapp,
});

Maintenance.defaultProps = {
    whatsapp: null,
};

Maintenance.propTypes = {
  whatsapp: PropTypes.shape({
    number: PropTypes.string,
  }),
};

export default connect(mapStateToProps)(Maintenance);
